import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Manifesto from "./components/Manifesto";
import PmeSection from "./components/PmeSection";
import IndividuelSection from "./components/IndividuelSection";
import About from "./components/About";
import ImageBreak from "./components/ImageBreak";
import Testimonials from "./components/Testimonials";
import Modalites from "./components/Modalites";
import ContactBooking from "./components/ContactBooking";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-[#0A1120] text-slate-100">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <PmeSection />
        <IndividuelSection />
        <About />
        <ImageBreak />
        <Testimonials />
        <Modalites />
        <ContactBooking />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}
